import { render, staticRenderFns } from "./AprovalSOS.vue?vue&type=template&id=69325b9c&scoped=true"
import script from "./AprovalSOS.vue?vue&type=script&lang=js"
export * from "./AprovalSOS.vue?vue&type=script&lang=js"
import style0 from "./AprovalSOS.vue?vue&type=style&index=0&id=69325b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69325b9c",
  null
  
)

export default component.exports